const pad2 = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

export const parseApiDatetimeToMs = (datetime: string): number => {
  const normalized = datetime.trim().includes('T')
    ? datetime.trim()
    : datetime.trim().replace(' ', 'T');
  const ms = new Date(normalized).getTime();
  return ms;
};

export type ServerTimerSync = {
  remainingSecondsAtSync: number;
  syncedAtPerformanceMs: number;
};

export const createServerTimerSync = (
  expiryDatetime: string,
  currentDatetime: string
): ServerTimerSync => {
  const expiryMs = parseApiDatetimeToMs(expiryDatetime);
  const currentMs = parseApiDatetimeToMs(currentDatetime);

  const remainingMs = expiryMs - currentMs;

  return {
    remainingSecondsAtSync: Math.max(0, Math.floor(remainingMs / 1000)),
    syncedAtPerformanceMs: performance.now()
  };
};

export const getTimerExpiryState = (
  expiryDatetime: string,
  currentDatetime: string
): boolean => {
  const expiryMs = parseApiDatetimeToMs(expiryDatetime);
  const currentMs = parseApiDatetimeToMs(currentDatetime);
  const isTimerExpired = expiryMs <= currentMs;

  return isTimerExpired;
};

export const formatRemainingLabel = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safe / 3600);

  if (hours > 0) {
    const minutesInHour = Math.floor((safe % 3600) / 60);
    return `${hours} hr : ${pad2(minutesInHour)} min`;
  }

  const totalMinutes = Math.floor(safe / 60);
  return `${totalMinutes} min : ${pad2(safe % 60)} sec`;
};

export const getRemainingSeconds = (sync: ServerTimerSync | null): number => {
  if (!sync) {
    return 0;
  }

  const elapsedSeconds =
    (performance.now() - sync.syncedAtPerformanceMs) / 1000;

  return Math.max(0, Math.floor(sync.remainingSecondsAtSync - elapsedSeconds));
};
